import { render, staticRenderFns } from "./layoutSidenav_content.vue?vue&type=template&id=c8381574&scoped=true&"
import script from "./layoutSidenav_content.vue?vue&type=script&lang=js&"
export * from "./layoutSidenav_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8381574",
  null
  
)

export default component.exports